/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState, useRef } from 'react';
import { ListGroupItem } from 'reactstrap';
import { SmlsPopover } from '../Popover';
import { SmlsSwitch } from '../Switch';
import { mapToCssModules } from '../../utils/className';
export const SmlsListItem = ({ id, idLabelPrimary, idLabelSecondary, idTypeIcon, idAuxiliarText, icon, type = 'basic', infoText = 'popover', buttonType = 'select', label, caption, item, resultText, dark = false, onClick = () => undefined, onSwitch = () => undefined, onKeyDown = () => undefined, switchId, bgEmpty = false, disabled, className, }) => {
    const [showInfo, setShowInfo] = useState(false);
    const thisRef = useRef(null);
    const isBasicOrButton = type !== 'switch' && type !== 'text';
    const handleOnClickItem = (event) => {
        if (disabled)
            return;
        if (type === 'info') {
            setShowInfo((prevState) => !prevState);
        }
        if (buttonType !== 'remove') {
            onClick(event);
        }
    };
    const handleOnClickClose = (event) => {
        if (disabled)
            return;
        if (type === 'button' && buttonType === 'remove') {
            onClick(event);
        }
    };
    const handleKeyDown = (event) => {
        if (disabled)
            return;
        if (event.key === 'Enter') {
            if (!thisRef.current)
                return;
            thisRef.current.click();
        }
        if (onKeyDown)
            onKeyDown(event);
    };
    return (React.createElement(ListGroupItem, { id: id, className: mapToCssModules([dark ? 'dark' : '', className]), disabled: disabled },
        React.createElement("button", { type: "button", ref: thisRef, onClick: handleOnClickItem, onKeyDown: handleKeyDown, className: mapToCssModules([
                label || caption ? 'high' : '',
                label ? 'label' : '',
                caption ? 'caption' : '',
                type === 'button' && buttonType === 'remove' ? 'removable' : '',
                bgEmpty ? 'removable' : '',
            ]), tabIndex: type === 'switch' ? -1 : undefined, disabled: disabled },
            React.createElement("div", { className: "smls-ignore-click", tabIndex: -1 },
                icon,
                label && !caption && React.createElement("label", null, label),
                React.createElement("div", { className: "smls-list-main-content" },
                    React.createElement("p", { id: idLabelPrimary }, item),
                    caption && React.createElement("label", { id: idLabelSecondary }, caption)),
                type === 'info' && (React.createElement(React.Fragment, null,
                    React.createElement("i", { id: idTypeIcon, className: "material-icons notranslate smls-button-icon__info smls-list-icon" }, "\uE88E"),
                    React.createElement(SmlsPopover, { isVisible: showInfo, position: "left", content: infoText }))),
                type === 'error' && (React.createElement(React.Fragment, null,
                    React.createElement("i", { id: idTypeIcon, className: "material-icons notranslate smls-button-icon__error smls-list-icon" }, "\uE8B2"))),
                type === 'button' && buttonType === 'remove' ? (React.createElement("i", { tabIndex: -1, className: "material-icons", onClick: handleOnClickClose }, "\uE5CD")) : (type === 'button' && (React.createElement("i", { tabIndex: -1, id: idTypeIcon, className: "material-icons notranslate smls-list-icon" }, "\uE315"))),
                type === 'switch' && (React.createElement(SmlsSwitch, { id: `${switchId || 'switch'}`, onClick: onSwitch, dark: dark })),
                type === 'text' && (React.createElement("div", { className: "smls-list-text" },
                    React.createElement("p", { id: idAuxiliarText }, resultText)))))));
};
//# sourceMappingURL=index.js.map